import _Object$assign from 'babel-runtime/core-js/object/assign';
var modulesFiles = require.context('./', true, /.js$/);

export default modulesFiles.keys().filter(function (item) {
  return !['./index.js', './axios.js'].includes(item);
}).map(function (key) {
  return modulesFiles(key).default;
}).reduce(function (a, b) {
  return _Object$assign(a, b);
});